import {
    CANDIDATE_CATEGORY_FIELDS,
    CANDIDATE_INPUT_INFO_TYPES,
    INDUSTRY_FUNCTIONS,
    LOCAL_STORAGE_USER_LOGIN_INFO,
    MJ_CANDIDATE_CATEGORY_FIELDS,
    RC_CANDIDATE_CATEGORY_FIELDS,
    ResponseCode as ResponseStatus
} from "@app/constants/Common";
import * as CandidateService from "@app/services/CandidateService";
import { searchAllInputInfo } from "@app/services/CandidateService";
import { arrayIncludeItem, stringToArray } from "@app/utils/CommonUtils";
import { showSuccessMessageSaveData } from "@pages/candidate/Common";
import { cloneDeep } from "lodash";
import React, { useEffect, useState } from 'react';
import ReactChipInput from "react-chip-input";
import Select from "react-select";
import { toast } from "react-toastify";

export const CandidateCategoriesMode = {
    NORMAL_CATEGORY: 1,
    MJ_CATEGORY: 2,
    RC_CATEGORY: 3,
}

const CandidateCategories = (props) => {
    const [userLoginInfo, setUserLoginInfo] = useState({});
    const [isEditCategories, setIsEditCategories] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [categoryFields, setCategoryFields] = useState(CANDIDATE_CATEGORY_FIELDS);
    const [categories, setCategories] = useState({});
    const [allCategories, setAllCategories] = useState({});
    const {
        candidateId,
        categoryMode,
        initialCategories,
        isAllUsers,
        mode='Edit',
        isEdit = false,
        onChange,
        onSave,
    } = props

    useEffect(() => {
        setIsEditCategories(isEdit);
    }, [isEdit]);

    useEffect(() => {
        setCategories(initialCategories || {});
    }, [initialCategories]);

    const fetchCategories = async (canId) => {
        setIsLoading(true)
        const res = await CandidateService.getCandidateCategoryDetail(canId, isAllUsers)
        setIsLoading(false)
        if (res.sts_code === ResponseStatus.SUCCESS) {
            setCategories(res.content)
        }
        const allCategoryList = await searchAllInputInfo(canId, CANDIDATE_INPUT_INFO_TYPES.CandidateCategory)
        setAllCategories(cloneDeep(allCategoryList))
    };

    useEffect(() => {
        if (!userLoginInfo.id && localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)) {
            setUserLoginInfo(JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)))
        }
        if (candidateId) {
            fetchCategories(candidateId);
        }
    },[candidateId]);

    useEffect(() => {
        if (categoryMode === CandidateCategoriesMode.MJ_CATEGORY) {
            setCategoryFields(MJ_CANDIDATE_CATEGORY_FIELDS);
        } else if (categoryMode === CandidateCategoriesMode.RC_CATEGORY) {
            setCategoryFields(RC_CANDIDATE_CATEGORY_FIELDS);
        }
    },[categoryMode]);

    const onAddCategoryItem = (value, fieldName) => {
        if (!value) {
            return;
        }
        let arr = cloneDeep(categories[fieldName])
        if (!arr) {
            arr = []
        }

        if (!arrayIncludeItem(arr, value)) {
            arr.push(value)
            categories[fieldName] = arr
            setCategories({...categories})
            if (onChange) {
                onChange(categories);
            }
        } else {
            alert('Không được phép nhập các giá trị giống nhau tại cùng 1 trường.')
        }
    }

    const updateCandidateCategories = () => {
        // Check xem trong số các trường sử dụng chung, giá trị đã đc nhập bởi user khác cho UV này chưa
        // Nếu có user khác nhập cho UV này giá trị rồi => báo lỗi, ko save thông tin vào DB.
        // categories.allCandidateCategoriesInfo = allInputInfo.allCandidateCategoriesInfo
        // if (checkExistsCommonFieldValues(categories, userLoginInfo.id)) {
        //     return;
        // }
        setIsLoading(true)
        CandidateService.updateCandidateCategoriesDetail({candidate_id: candidateId, categories: categories}).then((res) => {
            console.log(JSON.stringify(res))
            showSuccessMessageSaveData(res.sts_code)
            setIsEditCategories(false)
        }).catch((error) => {
            toast.error(`Có lỗi xảy ra trong quá trình xử lý.`);
        }).finally(() => {
            setIsLoading(false)
        });
    };

    const onRemoveCategoryItem = (index, fieldName) => {
        let arr = cloneDeep(categories[fieldName])
        if (arr && arr.length > 0) {
            if (arr.length === 1) {
                arr = []
            } else {
                arr.splice(index, 1);
            }
            categories[fieldName] = arr
            setCategories({...categories})
            if (onChange) {
                onChange(categories);
            }
        }
    }

    const onChangeCategoryItem = (event, fieldName) => {
        if (fieldName === 'industry_function') {
            categories[fieldName] = event
        } else {
            categories[event.target.name] = event.target.value
        }
        setCategories({...categories})
        if (onChange) {
            onChange(categories);
        }
    }

    const inputDisableView = (values, index) => {
        return <input type='text' className='form-control' disabled={'disabled'}
                      style={{
                          position: 'absolute',
                          width: '100%',
                          top: 32,
                          height: '55%',
                          backgroundColor: 'rgba(233, 236, 239,0.4)'
                      }} />;
    }

    const onCopyFromCategoryAndFlowTab = () => {
        if (categoryMode === CandidateCategoriesMode.MJ_CATEGORY) {
            categories.mj_industry = Array.from(new Set([
                ...(categories.mj_industry || []), ...(allCategories.flatMap(item => stringToArray(item.industry)))
            ]));
            categories.mj_industry_segment1 = Array.from(new Set([
                ...(categories.mj_industry_segment1 || []), ...(allCategories.flatMap(item => stringToArray(item.industry_segment1)))
            ]));
            categories.mj_industry_segment2 = Array.from(new Set([
                ...(categories.mj_industry_segment2 || []), ...(allCategories.flatMap(item => stringToArray(item.industry_segment2)))
            ]));
            categories.mj_function = Array.from(new Set([
                ...(categories.mj_function || []), ...(allCategories.flatMap(item => stringToArray(item.function)))
            ]));
            categories.mj_function_segment1 = Array.from(new Set([
                ...(categories.mj_function_segment1 || []), ...(allCategories.flatMap(item => stringToArray(item.function_segment1)))
            ]));
            categories.mj_function_segment2 = Array.from(new Set([
                ...(categories.mj_function_segment2 || []), ...(allCategories.flatMap(item => stringToArray(item.function_segment2)))
            ]));
        }
        else if (categoryMode === CandidateCategoriesMode.RC_CATEGORY) {
            categories.rc_industry = Array.from(new Set([
                ...(categories.rc_industry || []), ...(allCategories.flatMap(item => stringToArray(item.industry)))
            ]));
            categories.rc_industry_segment1 = Array.from(new Set([
                ...(categories.rc_industry_segment1 || []), ...(allCategories.flatMap(item => stringToArray(item.industry_segment1)))
            ]));
            categories.rc_industry_segment2 = Array.from(new Set([
                ...(categories.rc_industry_segment2 || []), ...(allCategories.flatMap(item => stringToArray(item.industry_segment2)))
            ]));
            categories.rc_function = Array.from(new Set([
                ...(categories.rc_function || []), ...(allCategories.flatMap(item => stringToArray(item.function)))
            ]));
            categories.rc_function_segment1 = Array.from(new Set([
                ...(categories.rc_function_segment1 || []), ...(allCategories.flatMap(item => stringToArray(item.function_segment1)))
            ]));
            categories.rc_function_segment2 = Array.from(new Set([
                ...(categories.rc_function_segment2 || []), ...(allCategories.flatMap(item => stringToArray(item.function_segment2)))
            ]));
        }
        setCategories({...categories})
    }

    return (
        <div className='card card-default'>
            <div className='card-header'>
                <h3 className='card-title text-bold'>Phân loại</h3>
                {mode !=='Search' &&
                <div className='card-tools'>
                    {isEditCategories &&
                        <button type='button'
                                className='btn btn-default mr-2'
                                onClick={() => {
                                    setIsEditCategories(false);
                                }}
                        >
                            Cancel
                        </button>
                    }
                    {isEditCategories &&
                        <button type='button'
                                className='btn btn-default mr-2'
                                onClick={onCopyFromCategoryAndFlowTab}>
                            Copy từ tab phân loại & luồng
                        </button>
                    }
                    {isEditCategories &&
                        <button type='button'
                                className='btn btn-primary'
                                onClick={() => {
                                    updateCandidateCategories();
                                }}
                        >
                            Save
                        </button>
                    }
                    {!isEditCategories &&
                        <button type='button'
                                className='btn btn-default'
                                onClick={() => {
                                    setIsEditCategories(true);
                                }}
                        >
                            Edit
                        </button>
                    }
                </div>
                }
            </div>
            <div className='card-body mt-0'>
                {categoryFields.map((field, i) => {
                    let fieldValue = categories[field.key] ? categories[field.key] : []
                    if (field.key === 'industry_function') {
                        return <div className='input-group mt-3'>
                            <label className={'w-100'}><b>Industry Function
                                (Linkedin)</b></label>
                            <div style={{width: '100%'}}>
                                <Select options={INDUSTRY_FUNCTIONS} isMulti
                                        isDisabled={!isEditCategories}
                                        value={categories.industry_function}
                                        onChange={value => {
                                            onChangeCategoryItem(value, 'industry_function');
                                        }}
                                />
                                {/*<AllUserInputField*/}
                                {/*    arrInfo={allInputInfo.allCandidateCategoriesInfo}*/}
                                {/*    field='industry_function'/>*/}
                            </div>
                        </div>
                    }

                    return <div className='input-group mt-3'>
                        <label className={'w-100'}>{field.label}</label>
                        <ReactChipInput
                            classes="class1 class2 w-100"
                            chips={fieldValue}
                            onSubmit={value => onAddCategoryItem(value, field.key)}
                            onRemove={index => onRemoveCategoryItem(index, field.key)}
                        />
                        {!isEditCategories && inputDisableView(fieldValue, i)}
                        {/*<AllUserInputField arrInfo={allInputInfo.allCandidateCategoriesInfo}*/}
                        {/*                   field={field.key}/>*/}
                    </div>
                })}
            </div>
        </div>
    );
};

export default CandidateCategories;
